import Vue from 'vue';
import PortalVue from 'portal-vue';
import BaseModal from '@rmpenterprise/base-modal';
import { VuetableFieldCheckbox } from 'vuetable-2';
import VueRouter from 'vue-router';
import Vuelidate from 'vuelidate';
import { VueClipboard } from './bootstrap';
import EventBusPlugin from './event-bus';
import { routes, EventsRoutes } from './routes';
import EventsStore from './vuex/events/index';
import EmailAutomationListsStore from './vuex/email-automation-lists/index';

// Events
import EventsLayout from './components/events/index.vue';
import '@rmpenterprise/form-date-picker/dist/date-picker.esm.css';

// Dashboard Widgets
import WidgetComponent from './components/dashboard/widget-render.vue';
import TableComponent from './components/dashboard/widgets/table.vue';
import TotalStatsComponent from './components/dashboard/widgets/total-stats.vue';
import FlashMessage from './components/common/flash-message.vue';
import DatePicker from './components/dashboard/common/datepicker.vue';
import DashboardInitialiserComponent from './components/dashboard/dashboard-initialiser.vue';
import EmailAutomationListsLayout from './components/email-automation-lists/layout/layout.vue';
import RenderAllSectionsForPreferenceCenterComponent from './components/student-preference-center/render-all-elements.vue';
import SetFieldsForPreferenceCenterComponent from './components/student-preference-center/elements/subscribed-fields.vue';
import SetSectionsForPreferenceCenterComponent from './components/student-preference-center/elements/subscribed-sections.vue';
import SetCompanyDetailsForPreferenceCenterComponent from './components/student-preference-center/elements/company-details.vue';
import GetCompanyPreferenceCenterLinkComponent from './components/student-preference-center/elements/get-link.vue';

Vue.use(EventBusPlugin);
Vue.use(Vuelidate);
Vue.use(VueRouter);
Vue.use(PortalVue);

// This needs attention. Apparently this must be registered globally to use it inside vuetable-2
Vue.component('VuetableFieldCheckbox', VuetableFieldCheckbox);

const router = new VueRouter({
  mode: 'history',
  base: 'sms/',
  routes,
});

const eventRouter = new VueRouter({
  mode: 'history',
  base: 'events/',
  routes: EventsRoutes,
});

window.vm = new Vue();
vm.$options.router = router;

if (document.getElementById('portal-vue')) {
  new Vue({
    el: '#portal-vue',
    components: {
      BaseModal,
    },
  });
}

/* eslint no-new: "off" */
// Vue requires 'new' keyword
if (document.getElementById('vue-dashboard')) {
  new Vue({
    el: '#vue-dashboard',
    components: {
      'table-component': TableComponent,
      'total-stats-component': TotalStatsComponent,
      'flash-message': FlashMessage,
      'widget-component': WidgetComponent,
    },
  });

  new Vue({
    el: '#WidgetControls',
    components: {
      'date-picker': DatePicker,
    },
  });
}

if (document.getElementById('Dashboard-initialiser')) {
  new Vue({
    el: '#Dashboard-initialiser',
    components: {
      'flash-message': FlashMessage,
      'dashboard-initialiser': DashboardInitialiserComponent,
    },
  });
}

/**
 * Student Preference Center
 */
Vue.use(VueClipboard);
if (document.getElementById('vue-student-preference-center')) {
  new Vue({
    el: '#vue-student-preference-center',
    components: {
      'flash-message': FlashMessage,
      'set-fields-component': SetFieldsForPreferenceCenterComponent,
      'set-sections-component': SetSectionsForPreferenceCenterComponent,
      'set-company-details-component': SetCompanyDetailsForPreferenceCenterComponent,
      'student-preference-centre-component': RenderAllSectionsForPreferenceCenterComponent,
      'get-link-component': GetCompanyPreferenceCenterLinkComponent,
    },
  });
}

if (document.getElementById('EventsNavigation')) {
  new Vue({
    el: '#EventsNavigation',
    store: EventsStore,
    router: eventRouter,
    components: {
      'flash-message': FlashMessage,
      layout: EventsLayout,
    },
  });
}

if (document.getElementById('EmailAutomationLists')) {
  new Vue({
    el: '#EmailAutomationLists',
    store: EmailAutomationListsStore,
    router,
    components: {
      'flash-message': FlashMessage,
      layout: EmailAutomationListsLayout,
    },
  });
}
